export const notificationsEndpoints = {
  list: () => "/notification",
  update: (notificationId: string) => `/notification/${notificationId}`,
};
